import moment from 'moment';
import createCalendarData from '../utils/calendar';

export const initialState = {
  currentMoment: null,
  currentCalendar: [],
  currentMonthYear: null,
  startMonth: null,
  endMonth: null,
  initialDate: null,
  selectedDate: null,
  arrowBack: false,
  arrowNext: false,
  enableButton: false,
  calendar: {},
  endDate: null,
};

export const createCalendar = (state: Object, action: Object) => {
  const { payload: depotDirect } = action;
  const originalMoment = moment(depotDirect.originalDeliveryDate);
  const currentMoment = moment(depotDirect.currentDeliveryDate);
  const currentDeliveryDate = currentMoment.format('YYYY-MM-DD');
  const currentMonth = currentMoment.month();
  const currentMonthYear = currentMoment.format('MMMM YYYY');
  const endMonth = originalMoment
    .clone()
    .add(30, 'days')
    .month();

  const calendar = createCalendarData(currentDeliveryDate, endMonth);
  return {
    ...state,
    currentMoment,
    currentCalendar: calendar[currentMonth],
    currentMonthYear,
    startMonth: currentMoment.clone().month(),
    endMonth,
    initialDate: currentDeliveryDate,
    selectedDate: currentDeliveryDate,
    calendar,
    arrowNext: currentMoment.clone().month() !== endMonth,
    endDate: originalMoment.clone().add(30, 'days'),
  };
};

export const updateApplianceCalendarMonth = (state: Object, action: Object) => {
  const {
    payload: { target },
  } = action;
  const { name } = target;
  const { currentMoment, startMonth, endMonth, calendar } = state;
  const updatedMoment =
    name === 'next'
      ? currentMoment.add(1, 'month')
      : currentMoment.subtract(1, 'month');
  const updatedMonth = updatedMoment.month();
  return {
    ...state,
    currentMoment: updatedMoment,
    currentCalendar: calendar[updatedMonth],
    currentMonthYear: updatedMoment.format('MMMM YYYY'),
    arrowBack: updatedMonth !== startMonth,
    arrowNext: updatedMonth !== endMonth,
  };
};

export const updateApplianceDeliveryDate = (state: Object, action: Object) => {
  const {
    payload: { target },
  } = action;
  const { name } = target;
  return {
    ...state,
    selectedDate: name,
    enableButton: name !== state.initialDate,
  };
};
